// make sure we are using https
if (typeof window !== "undefined") {
  if (window.location.protocol !== 'https:') {
    window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
  }
}

import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
//import { createI18n } from 'vue-i18n'
//import VueWebSpeech from 'vue-web-speech'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import './app.scss'

import AppLayout from '@/layouts/AppLayout.vue'
import SubMenu from '@/layouts/SubMenu.vue'
import ShowIcon from '@/components/ShowIcon'
import GoBackButton from '@/components/GoBackButton.vue'
import PageHeader from '@/components/PageHeader'

import { i18n } from './i18n'
//import en from "@/locales/en"
//import es from "@/locales/es"

//import { setInstance } from '@/common/instance'
//import { useInstance } from '@/common/use_instance'

//const i18n = createI18n({
//  legacy: false,
//  locale: 'en',
//  messages: {
//    en: en,
//    es: es
//  }
//});

/*
router.beforeEach((to, from) => {
  //setInstance(to);
  console.log("Inside common/instance.js setInstance, to.params.instance ==> ", to.params.instance);
  console.log("Inside common/instance.js setInstance, router ==> ", router);
  console.log("Inside common/instance.js setInstance, router.app ==> ", router.app);
  //instance.setInstance(to);
  useInstance(to);
});
*/

const app = createApp(App).use(i18n).use(store).use(router).use(mdiVue, {
  icons: mdijs
});
app.config.performance = true;

//app.use(VueWebSpeech)
app.component("app-layout", AppLayout);
app.component("sub-menu", SubMenu);
app.component("show-icon", ShowIcon);
app.component("go-back-button", GoBackButton);
app.component("loading", Loading);
app.component("page-header", PageHeader);

app.mount('#app');